import React, { useState } from "react";
import "../css/cancelButton.css";
import { CloseCircleIcon } from "../../../../../asset-controller-mod/asset-serv/icons/iconExporter";


export interface CancelButtonProps {
  onClick?: () => void;
  disabled?: boolean;
  className?: string;
  "aria-label"?: string;
}

// ─── Component ────────────────────────────────────────────────────────────────

const CancelButton: React.FC<CancelButtonProps> = ({
  onClick,
  disabled = false,
  className = "",
  "aria-label": ariaLabel = "Cancel",
}) => {
  const [hovered, setHovered] = useState(false);

  return (
    <button
      type="button"
      className={[
        "scl--cms-components-cancelButton",
        hovered && !disabled ? "scl--cms-components-cancelButton--hover" : "scl--cms-components-cancelButton--default",
        disabled ? "scl--cms-components-cancelButton--disabled" : "",
        className,
      ]
        .filter(Boolean)
        .join(" ")}
      onClick={onClick}
      onMouseEnter={() => !disabled && setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      disabled={disabled}
      aria-label={ariaLabel}
    >
      <CloseCircleIcon />
    </button>
  );
};

export default CancelButton;